import { addValueToObject } from "utils/objectUtils";
import INIT_STATE from "./initState";

export const ACTIONS = {
  INIT: 'init',
  ITEM_INFO: 'itemInfo',
  TRANSLATIONS: 'translations',
  CONFIG: 'config',
  CONFIG_MESSAGE: 'message',
  CONFIG_AVAILABILITY: 'availability',
  RESET: 'reset',
};

const Reducer = (state = INIT_STATE(), action) => {

  switch (action.type) {
    case ACTIONS.INIT: { 
      const newState = {...action.payload};
      return newState;
    }
    case ACTIONS.ITEM_INFO: {
      const newState = { ...state, ...action.payload };
      newState.hasChanged = true;
      return newState;
    }
    case ACTIONS.TRANSLATIONS: {
      const newState = { ...state };
      const { lang, text, value } = action.payload;

      const translations = { ...newState.translations };
      translations[lang][text] = value;

      newState.translations = translations;
      newState.hasChanged = true;

      return newState;
    }
    case ACTIONS.CONFIG: {
      const newState = { ...state };
      const { key, value } = action.payload;

      const config = { ...newState.config };   
        
      addValueToObject(config, key, value);

      newState.config = config;
      newState.hasChanged = true;

      return newState;
    }
    case ACTIONS.CONFIG_MESSAGE: {
      const newState = { ...state };
      const { key, value } = action.payload;

      const config = { ...newState.config };
      const message = { ...config.message };
      
      addValueToObject(message, key, value);

      newState.config.message = message;
      newState.hasChanged = true;

      return newState;
    }
    case ACTIONS.CONFIG_AVAILABILITY: {
      const newState = { ...state };
      const value = action.payload;

      const config = { ...newState.config };
      const availability = { 
        ...config.availability,
        ...value
      };

      newState.config.availability = availability;
      newState.hasChanged = true;

      return newState;
    }
    case ACTIONS.RESET: {
      const newState = { ...state };
      newState.hasChanged = false;

      return newState;      
    }
    default:
      throw new Error(`Action of type ${action.type} not valid`);
  }
};

export default Reducer;
